export default __webpack_public_path__ + "d0d9cd55f174bee4ef43f69c3231a494.png";